import { Flex, Text, IconButton } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import styles from './CalendarView.module.css';

export default function YearNavigation({ selectedYear, onPrevious, onNext }) {
  const { t } = useTranslation('campaigns');

  return (
    <Flex className={styles.yearSelector} align="center">
      <Flex className={styles.yearNavigation} align="center">
        <IconButton
          className={styles.yearNavigationButton}
          onClick={onPrevious}
          aria-label={t('calendar.previousYear')}
          variant="soft"
          color="gray"
          size="2"
        >
          <i className="fa-solid fa-chevron-left" />
        </IconButton>
        <IconButton
          className={styles.yearNavigationButton}
          onClick={onNext}
          aria-label={t('calendar.nextYear')}
          variant="soft"
          color="gray"
          size="2"
        >
          <i className="fa-solid fa-chevron-right" />
        </IconButton>
        <Text className={styles.yearDisplay} size="4" weight="bold">
          {selectedYear}
        </Text>
      </Flex>
    </Flex>
  );
}
